// extracted by mini-css-extract-plugin
export var label = "_dn-5";
export var slideContainer = "_dn-0";
export var slider = "_dn-1";
export var sliderLg = "_dn-4";
export var sliderMd = "_dn-3";
export var sliderSm = "_dn-2";